// 3rd party imports
import * as React from 'react';
import { inject } from 'mobx-react';

import { Link } from 'react-router-dom';

// bernie
import { AnalyticsStore, ContextStore } from 'bernie-plugin-mobx';

// shared-ui
import { ILocalization, withLocalization, LocalizedText } from '@shared-ui/localization-context';

// mobx
import { IndustryStore, UserStore, UserAuthStore, CountriesStore } from 'stores';

// ui
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading } from 'uitk-react-text';
import { UitkBanner } from 'uitk-react-banner';
import { UitkLink } from 'uitk-react-link';
import { UitkText } from 'uitk-react-text';
import { UitkTertiaryButton } from 'uitk-react-button';
import { UitkCard } from 'uitk-react-cards';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';

// components
import { SignupAHForm } from './signup-ah-form';
import { SignupAHConfirmation } from './signup-ah-confirmation';

import { RouteComponentProps, withRouter } from 'react-router-dom';

import { modifyLocaleParam } from '../../util/locale-param-transformer';

interface SignupAHProps extends RouteComponentProps {
  analytics?: AnalyticsStore;
  context?: ContextStore;
  industries?: IndustryStore;
  countriesStore?: CountriesStore;
  l10n?: ILocalization;
  user?: UserStore;
  userAuth?: UserAuthStore;
}

interface SignupAHState {
  showConfirmation: boolean;
  email: string;
  verificationEmailError: string;
  countries: Map<string, string>;
}

@withLocalization
@inject('analytics', 'industries', 'countriesStore', 'user', 'context', 'userAuth')
// FIXME: DEPRECATED maybe?
class Signup extends React.Component<SignupAHProps, SignupAHState> {
  public constructor(props) {
    super(props);

    this.state = {
      showConfirmation: false,
      email: '',
      verificationEmailError: '',
      countries: new Map<string, string>(),
    };

    this.props.countriesStore.fetchForLocale(this.props.context.locale);
  }

  public componentDidMount() {
    this.setState({
      countries: this.props.countriesStore.countries,
    });
  }

  public componentDidUpdate() {
    const queryParams = new URLSearchParams(this.props.history.location.search);
    if (queryParams) {
      const email = queryParams.get('email');
      const { showConfirmation } = this.state;
      if (email && !showConfirmation) {
        this.setState({
          showConfirmation: true,
          email,
        });
      }
    }
  }

  public onVerificationEmailError = () => {
    this.setState({
      verificationEmailError: 'Email communication failed. Please try again',
      countries: this.props.countriesStore.countries,
    });
  };

  public render() {
    const { showConfirmation, email, verificationEmailError, countries } = this.state;

    const { locale } = this.props.context;

    return (
      <>
        {showConfirmation ? (
          <UitkSpacing className="container--small-1" padding={{ block: 'twelve' }}>
            <main>
              <SignupAHConfirmation email={email} verificationEmailError={verificationEmailError} />
            </main>
          </UitkSpacing>
        ) : (
          <>
            <UitkSpacing className="container--small" padding={{ block: 'twelve' }}>
              <main>
                <UitkSpacing margin={{ blockend: 'twelve' }}>
                  <UitkCard>
                    <UitkSpacing padding={{ block: 'six', inline: 'six' }}>
                      <UitkLayoutFlex alignItems="center" justifyContent="space-between" wrap="wrap">
                        <UitkText>Earn up to 6% commission with the Expedia Group Affiliate Program</UitkText>
                        <UitkLink size="large" inline={true}>
                          <Link to={`/${modifyLocaleParam(locale)}/commercial-terms`}>Learn more</Link>
                        </UitkLink>
                      </UitkLayoutFlex>
                    </UitkSpacing>
                  </UitkCard>
                </UitkSpacing>
                <UitkSpacing padding={{ blockend: 'six' }}>
                  <UitkHeading tag="h1" size={3} align="center">
                    <LocalizedText message="signup.page.title" />
                  </UitkHeading>
                </UitkSpacing>
                <SignupAHForm onVerificationEmailError={this.onVerificationEmailError} countries={countries} />
              </main>
            </UitkSpacing>
          </>
        )}
      </>
    );
  }
}

export const SignupAH = withRouter(Signup);
